export const EVENT_ROUTES = {
	LIST: "/events",
	CREATE: "/events/create",
	PREVIEW: "/events/create/preview",
	DETAIL: "/events/:eventId",
	EDIT: "/events/:eventId/edit",
	PUBLIC_DETAIL: "/public/events/:eventId",
} as const;

export function eventPublicUrl(eventId: string): string {
	return `${window.location.origin}/public/events/${eventId}`;
}
